<div class="diff-wrapper">
    @if (dialogConfig?.data?.diff_check) {
    <div class="diff-table-container">
        <table class="diff-table">
            <thead>
                <tr>
                    <th style="text-align: center;">Field</th>
                    <th style="text-align: center;">Old Value</th>
                    <th style="text-align: center;">New Value</th>
                    <th style="text-align: center; width: 160px">Action</th>
                </tr>
            </thead>
            <tbody>
                <!-- <tr *ngFor="let row of diffRows" [ngClass]="row.status"> -->
                <tr *ngFor="let row of diffRows">
                    <td class="field-cell">
                        {{ row.field }}
                    </td>
                    <td class="value-cell">
                        <pre>{{ row.oldValue || '—' }}</pre>
                    </td>
                    <td class="value-cell">
                        <pre>{{ row.newValue || '—' }}</pre>
                    </td>
                    <td class="status-cell">
                        <span *ngIf="row.status === 'added'" class="status-badge added-badge">Added</span>
                        <span *ngIf="row.status === 'removed'" class="status-badge removed-badge">Removed</span>
                        <span *ngIf="row.status === 'updated'" class="status-badge changed-badge">Updated</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    }
    <div id="jsoneditor" class="editor"></div>
</div>